// Helper functions for service styling
import { PiChartBar, PiHeart, PiLighthouse } from 'react-icons/pi';

export const getIconForService = (
  service: any,
  stateName?: string
): React.ReactNode => {
  switch (service.name) {
    case 'Nav_light':
      return <PiLighthouse />;
    case 'Station_Health':
      return <PiHeart />;
    default:
      return <PiChartBar />;
  }
};
export const getVariantForState = (
  service: any,
  stateName: string,
  index: number
): 'success' | 'destructive' | 'warning' | 'secondary' | 'default' => {
  if (stateName === 'FAIL' || stateName === 'ALARM') {
    return 'destructive';
  }
  if (stateName === 'ON' || stateName === 'NORMS') {
    return 'success';
  }
  if (stateName === 'OFF' || stateName === 'NOT_MONITOR') {
    return 'secondary';
  }
  return 'default';
};
